import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./style.scss";

interface RichTextEditorProps {
  value: string | any;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  formats?: string[];
  modules?: object;
}

const defaultFormats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const defaultModules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};

const CustomTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  onBlur,
  placeholder = "Enter text here...",
  formats = defaultFormats,
  modules = defaultModules,
}) => {
  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      formats={formats}
      modules={modules}
      onBlur={onBlur}
    />
  );
};

export default CustomTextEditor;
